export default "<main-nav>\n  <router-outlet></router-outlet>\n</main-nav>"